<!--
2024-06-02 YTW 邀请员任务
-->
<template>
  <div class="main-content" id="main-content" @scroll="scrollListen">
    <div class="relative">
      <img :src="shareBk" alt="" class="shareBk"/>
      <TopBack style="position: relative" :title="$t('lang.shareFiesta.title')"/>
      <div class="banner">
        <img :src="banner" alt=""/>
      </div>
      <div class="dateSpan">{{ $t('lang.shareFiesta.date') + dateSpan }}</div>
      <div class="taskOuter">
        <div class="taskRows" ref="taskRows" @scroll="taskRowsScroll" v-if="taskSwitch">
          <div v-for="(task,index) in tasks" :key="index" class="row">
            <div class="name" :style="$store.state.locale==='IN'?'font-size:3.35vw':''">
              {{ changeLang(task) + task.TaskValue }}
            </div>
            <div class="amount"><img :src="money" alt=""/><span><span
              style="font-size: 3.333vw;">{{ 'X' }}</span>{{ task.RewardAmount }}</span></div>
            <div class="button">
              <div v-if="task.TaskStatus===0" class="btn0 btnBackground"
                   :style="{backgroundImage: 'url(' + require('../../assets/images/shareFiesta/claim.png') + ')',fontSize: $store.state.locale === 'IN' ? '2.55vw' : ''}"
                   @click="getMoney(task.TaskId)">
                {{ $t('lang.shareFiesta.btn0') }}
              </div> <!--可领取-->
              <div v-if="task.TaskStatus===1" class="btn2 btnBackground"
                   :style="{backgroundImage: 'url(' + require('../../assets/images/shareFiesta/claimed.png') + ')',fontSize: $store.state.locale === 'IN' ? '2.55vw' : ''}">
                {{ $t('lang.shareFiesta.btn1') }}
              </div> <!--已领取-->
              <div v-if="task.TaskStatus===-1" class="btn2 btnBackground"
                   :style="{backgroundImage: 'url(' + require('../../assets/images/shareFiesta/cantClaim.png') + ')',fontSize: $store.state.locale === 'IN' ? '2.55vw' : ''}">
                {{ $t('lang.shareFiesta.btn2') }}
              </div> <!--已过期-->
              <div v-if="task.TaskStatus===-2" class="btn1 btnBackground"
                   :style="{backgroundImage: 'url(' + require('../../assets/images/shareFiesta/cantClaim.png') + ')',fontSize: $store.state.locale === 'IN' ? '2.55vw' : ''}">
                {{ $t('lang.shareFiesta.btn0') }}
              </div> <!--未达标-->
              <div v-if="task.TaskStatus===-3" class="btn3 btnBackground"
                   :style="{backgroundImage: 'url(' + require('../../assets/images/shareFiesta/notstart.png') + ')',fontSize: $store.state.locale === 'IN' ? '2.55vw' : ''}">
                {{ $t('lang.shareFiesta.btn3') }}
              </div> <!--未开始-->
            </div>
          </div>
        </div>
        <div class="vapors" v-if="vaporShow">
          <div class="vaporsInner">
            <img :src="next" alt=""/>
          </div>
        </div>
      </div>
      <div class="showNow">
        <div class="inline">
          <div class="left">{{ $t('lang.shareFiesta.shareNow') }}</div>
          <div class="right">{{ $t('lang.shareFiesta.texts')[0] }}<span
            @click="clickMe">{{ $t('lang.shareFiesta.texts')[1] }}</span></div>
        </div>
        <div class="icons">
          <div class="shareIcon" @click="whatsappClick"><img :src="share1" alt=""/></div>
          <div class="shareIcon" @click="telegramClick"><img :src="share2" alt=""/></div>
          <div class="shareIcon" @click="facebookClick"><img :src="share3" alt=""/></div>
          <div class="shareIcon" @click="copyLinkClick"><img :src="share4" alt=""/></div>
        </div>
      </div>
      <div class="next" v-show="bottomShow"><img :src="next" alt=""/></div>
      <div class="rules">
        <div class="title">{{ $t('lang.promotion.rules') }}</div>
        <div class="content">
          <p v-for="(rule,index) in $t('lang.shareFiesta.rules')" :key="index">{{ rule }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import next from '@/assets/images/shareFiesta/next.svg'
import money from '@/assets/images/shareFiesta/money.png'
import banner from '@/assets/images/shareFiesta/banner1.webp'
import shareBk from '@/assets/images/shareFiesta/shareBk.webp'
import share1 from '@/assets/images/shareFiesta/whatsapp.png'
import share2 from '@/assets/images/shareFiesta/telegram.png'
import share3 from '@/assets/images/shareFiesta/facebook.png'
import share4 from '@/assets/images/shareFiesta/copylink.png'
import TopBack from '@/components/TopBack/index'
import {Toast} from 'mint-ui'
import request from '@/service'
import {fetchBalance} from '@/utils'

export default {
  name: 'ShareFiesta',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      shareCode: '',
      taskSwitch: false,
      dateSpan: '',
      next,
      money,
      banner,
      share1,
      share2,
      share3,
      share4,
      shareBk,
      fetchBalance,
      tasks: [],
      bottomShow: true,
      vaporShow: false,
      hasTaskScroll: false
    }
  },
  components: {
    TopBack
  },
  watch: {},
  created () {
  },
  mounted () {
    if (this.userInfo) {
      this.fetchAccount()
    }
    this.fetchTask()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    clickMe () {
      this.$router.push('/Earn')
    },
    fetchAccount () {
      let that = this
      const url = '/innovation/account/getuseraccount'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        that.shareCode = res.InviteLink
      }).catch(err => {
        console.log(err)
      })
    },
    fetchTask () {
      const url = '/innovation/invite_task/get_data'
      let data = {}
      if (this.userInfo) {
        data = {
          userId: this.userInfo.UserId
        }
      } else {
        data = {
          userId: ''
        }
      }
      request('post', url, data).then(res => {
        if (res) {
          this.dateSpan = this.formattedDate(res.Setting.StartDateIndia) + ' - ' + this.formattedDate(res.Setting.EndDateIndia)
          this.taskSwitch = res.Setting.ActivitySwitch
          // 产品要求把登录排在第一个
          if (res.TaskData) {
            res.TaskData.sort((a, b) => {
              if (a.TaskName === 'daily_login' && b.TaskName !== 'daily_login') {
                return -1
              }
              if (b.TaskName === 'daily_login' && a.TaskName !== 'daily_login') {
                return 1
              }
              return 0
            })
          }
          this.tasks = res.TaskData
          if (this.taskSwitch) {
            this.$nextTick(() => {
              const container = this.$refs.taskRows
              this.hasTaskScroll = container.scrollHeight > container.clientHeight
              this.vaporShow = this.hasTaskScroll
            })
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getMoney (taskId) {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      const url = '/innovation/invite_task/collect_reward'
      const data = {
        userId: this.userInfo.UserId,
        TaskId: taskId
      }
      request('post', url, data).then(res => {
        if (res) {
          if (res.RewardAmount && res.RewardAmount > 0) {
            this.fetchBalance()
            Toast(this.$t('lang.shareFiesta.msg').replace('{amount}', res.RewardAmount))
          }
          // 产品要求把登录排在第一个
          if (res.TaskData) {
            res.TaskData.sort((a, b) => {
              if (a.TaskName === 'daily_login' && b.TaskName !== 'daily_login') {
                return -1
              }
              if (b.TaskName === 'daily_login' && a.TaskName !== 'daily_login') {
                return 1
              }
              return 0
            })
          }
          this.tasks = res.TaskData
        }
      }).catch(err => {
        console.log(err)
      })
    },
    formattedDate (dateStr) {
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${day}/${month}/${year}`
    },
    changeLang (task) {
      let nameShow = ''
      switch (task.TaskName) {
        case 'login':
          nameShow = this.$t('lang.shareFiesta.tasks')[0]
          break
        case 'share':
          nameShow = this.$t('lang.shareFiesta.tasks')[1]
          break
        case 'share_create':
          nameShow = this.$t('lang.shareFiesta.tasks')[2]
          break
        case 'share_create_deposit':
          nameShow = this.$t('lang.shareFiesta.tasks')[3]
          break
        case 'invite_bet':
          nameShow = this.$t('lang.shareFiesta.tasks')[4]
          break
        case 'daily_login':
          nameShow = this.$t('lang.shareFiesta.tasks')[5]
          break
      }
      if (nameShow.indexOf('{amount}') > -1) {
        nameShow = nameShow.replace('{amount}', this.getSubstringAmount(task.TaskValue))
      }
      return nameShow
    },
    getSubstringAmount (str) {
      const slashIndex = str.indexOf('/')
      const rightParenthesisIndex = str.indexOf(')')
      return str.substring(slashIndex + 1, rightParenthesisIndex)
    },
    msgFormat () {
      let welcomeMessage = this.$t('lang.inviteFriends.inviteMsg')
      let index = this.shareCode.indexOf('/Share')
      if (index === -1) {
        index = this.shareCode.toLowerCase().indexOf('/share')
      }

      welcomeMessage = welcomeMessage.replace('{shareURL}', this.shareCode)
      welcomeMessage = welcomeMessage.replace('{amount1}', this.amount1)
      welcomeMessage = welcomeMessage.replace('{amount2}', this.amount2)
      welcomeMessage = welcomeMessage.replace('{amount3}', this.amount3)
      return welcomeMessage
    },
    telegramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Telegram')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://t.me/share/url?text=` + message + `&url=%20`)
    },
    whatsappClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('WhatsApp')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://wa.me/?text=${message}`, '_blank')
    },
    facebookClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Facebook')
      this.copyShares()
      window.open(`https://www.facebook.com/sharer.php?u=` + this.shareCode, '_blank')
    },
    copyShares () {
      let message = this.msgFormat()
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    copyLinkClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.copyShares()
      this.saveUserEvent('Link2')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo.UserId}
      request('post', url, data).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    getAddressBarHeight () {
      // 获取可视窗口高度
      const windowHeight = window.innerHeight
      // 获取文档的实际高度
      const documentHeight = document.querySelector('#main-content').clientHeight
      // 地址栏高度为二者之差
      return documentHeight - windowHeight
    },
    scrollListen () {
      const h = this.getAddressBarHeight()
      const scrollTop = document.querySelector('#main-content').scrollTop
      this.bottomShow = scrollTop < (5 + h)
    },
    taskRowsScroll () {
      const container = this.$refs.taskRows
      const isAtBottom = container.scrollHeight - Math.ceil(container.scrollTop) <= container.clientHeight
      this.vaporShow = !isAtBottom && this.hasTaskScroll
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: fixed;
  padding: 56px 0 70px 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;

  .relative {
    position: relative;
    width: 100%;
    height: max-content;
    z-index: 0;
  }

  .shareBk {
    position: absolute;
    top: -56px;
    width: 100%;
  }

  .banner {
    position: relative;
    top: -0.5vw;
    left: 3.05vw;
    width: 99.175vw;
    height: 40.555vw;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .dateSpan {
    position: relative;
    top: 0.5vw;
    text-align: center;
    font-size: 3.333vw;
    font-weight: 400;
    color: #AFA383;
    margin: 1vw auto;
  }

  .taskOuter {
    position: relative;
    top: 0;
    width: 100vw;
    height: 80.555vw;

    .taskRows {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;

      .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 14.444vw;
        background: radial-gradient(56.07% 797.08% at 50% 50%, rgba(36, 36, 4, 0.07) 0%, rgba(0, 0, 0, 0) 100%);
        padding: 0 4.066vw;
        border-bottom: 0.277vw solid;
        border-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #A69A58 50%, rgba(0, 0, 0, 0) 100%) 1;
        overflow: hidden;

        .name {
          width: 45.277vw;
          max-height: 8.333vw;
          line-height: 4.5vw;
          font-size: 3.75vw;
          font-weight: 500;
          text-align: left;
          color: #FFFFFF;
          letter-spacing: -0.06em;
        }

        .amount {
          font-size: 3.888vw;
          line-height: 3.888vw;
          font-weight: 500;
          text-align: left;
          color: #F6D9AA;
          display: flex;
          align-items: center;
          width: 15.277vw;
          justify-content: flex-start;

          img {
            height: 5vw;
            margin-right: 0.2vw;
          }
        }

        .button {
          width: 24.444vw;
          text-align: center;
          white-space: nowrap;

          .btn0 {
            width: 27.083vw;
            height: 11.944vw;
            line-height: 9.9vw;
            font-size: 4.444vw;
            font-weight: 500;
            text-align: center;
            color: #000000;
          }

          .btn1 {
            width: 27.083vw;
            height: 11.944vw;
            line-height: 9.9vw;
            font-size: 4.444vw;
            font-weight: 500;
            text-align: center;
            color: #000000;
          }

          .btnBackground {
            margin-top: 2vw;
            margin-right: 2vw;
            background-size: 100% 100%;
            background-position: top;
            background-repeat: no-repeat;
            text-transform: capitalize;
          }

          .btn2 {
            width: 27.083vw;
            height: 11.944vw;
            line-height: 9.9vw;
            font-size: 4.444vw;
            font-weight: 500;
            text-align: center;
            color: #838383;
            letter-spacing: -0.04em;
          }

          .btn3 {
            width: 27.083vw;
            height: 14.861vw;
            line-height: 11.8vw;
            font-size: 3.611vw;
            font-weight: 500;
            text-align: center;
            color: #868686;
            letter-spacing: -0.04em;
          }
        }
      }

      .row:last-child {
        border: none;
      }
    }

    .vapors {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: -13vw;
      width: max-content;
      height: 24vw;
      overflow: hidden;
      display: flex;
      align-items: flex-end;

      .vaporsInner {
        width: 95vw;
        height: 32.222vw;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.53) 30.73%, #000000 62.91%, rgba(0, 0, 0, 0) 100%);
        display: flex;
        justify-content: center;
        align-items: flex-end;
        img {
          width: 5.555vw;
          height: auto;
          margin-bottom: 9vw;
        }
      }
    }
  }

  .showNow {
    position: relative;
    top: 4.5vw;
    left: 50%;
    transform: translate(-50%);
    width: 88.888vw;
    height: 37.5vw;

    .inline {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      height: 6.388vw;
      text-transform: capitalize;

      .left {
        font-family: Inter;
        font-size: 5.277vw;
        line-height: 5.277vw;
        font-weight: 800;
        text-align: left;
        color: #FFFFFF;
      }

      .right {
        font-family: Inter;
        font-size: 3.333vw;
        line-height: 3.333vw;
        font-weight: 500;
        letter-spacing: 0.01em;
        text-align: right;
        color: #98999B;
        padding-bottom: 0.2vw;

        span {
          color: #006EAC;
          text-decoration: underline;
        }
      }
    }

    .icons {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 88.888vw;
      top: 3vw;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .shareIcon {
        width: 18.888vw;
        height: 24.444vw;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .next {
    position: relative;
    top: 3.05vw;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: auto;
      height: 2.5vw;
    }
  }

  .rules {
    position: relative;
    top: 5.3vw;
    left: 50%;
    transform: translate(-50%);
    width: 90.555vw;
    height: max-content;

    .title {
      font-family: Inter;
      font-size: 5.277vw;
      font-weight: 700;
      line-height: 6.388vw;
      text-align: left;
      color: #FFFFFF;
      margin-bottom: 2vw;
    }

    .content {
      padding: 2vw 0 0 1.111vw;
      font-family: Inter;
      font-size: 4.166vw;
      font-weight: 500;
      line-height: 6.111vw;
      text-align: left;
      color: #C5C5C5;
      height: max-content;

      p {
        margin-bottom: 1vw;
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/ShareFiesta/index.vue